<div
  class="kanban-chip-badge"
  [class.kanban-chip-badge-disabled]="disabled()"
  [class.kanban-chip-badge-compact]="compact()"
  [aionzTooltip]="tooltip() || ''"
  mode="message">
  @if (svgIcon()) {
    <mat-icon
      class="kanban-chip-badge-icon"
      [svgIcon]="svgIcon() || ''"
      [style.color]="color()"></mat-icon>
  } @else if (icon()) {
    <mat-icon
      class="kanban-chip-badge-icon"
      [style.color]="color()"
      >{{ icon() }}</mat-icon
    >
  }
  <span class="kanban-chip-badge-label" [attr.aria-hidden]="srLabel() ? 'true' : null">{{ label() }}</span>
  @if (srLabel()) {
    <span class="cdk-visually-hidden">{{ srLabel() }}</span>
  }
</div>
